import React from 'react';
import './client.scss';
import { CommonFilter } from './clientComponents/CommonFilter/commonFilter';
import ClientTab from './clientComponents/ClientTab/ClientTab';
import { MarketListContent } from './MarketListContent/MarketListContent';
import { observer } from 'mobx-react';
import { ClientStaffContent } from './clientStaffContent/clientStaffContent';
import { AOnStaffContent } from './AonStaffContent/AonStaffContent';
import { useClientPageStore } from '../../store';
var ClientPage = (observer(function () {
    var clientStore = useClientPageStore();
    return (React.createElement("div", { className: 'outer_wrapper' },
        React.createElement(CommonFilter, null),
        clientStore.selectedClientGuuid && clientStore.showClientFeatures &&
            React.createElement(ClientTab, { selectedClientGuuid: clientStore.selectedClientGuuid, elementOne: MarketListContent, elementTwo: ClientStaffContent, elementThree: AOnStaffContent, hideStaffTabs: clientStore.isCarrierMatrixClientSelected })));
}));
export default ClientPage;
